import { useHandleResponse } from '@/utils/useHandleResponse';
import { useMutation } from '@tanstack/react-query';
import { App, Button, Checkbox, Col, Divider, Form, Input, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import TextArea from 'antd/es/input/TextArea';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateField, updateProps } from '../../../contextRedux/SystemType/SystemTypeModel';
import SystemTypeService from '../../../services/systemType/SystemTypeService';
import { RootState } from '../../../store';
import useWindowSize from '../../../utils/useWindowSize';

const InfoDeviceForm: React.FC<any> = () => {
  const [form] = useForm();
  const { message } = App.useApp();
  const handleResponse = useHandleResponse();
  const dispatch = useDispatch();
  const width = useWindowSize();

  const systemType = useSelector((state: RootState) => state.models.systemType);

  const initialValues = {
    id: useSelector((state: RootState) => state?.models?.systemType?.id) ?? '',
    name: useSelector((state: RootState) => state?.models?.systemType?.name) ?? '',
    operations: useSelector((state: RootState) => state?.models?.systemType?.operations) ?? '',
    isActive: useSelector((state: RootState) => state?.models?.systemType?.isActive) ?? false,
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const fieldsValue = {
      ...form.getFieldsValue(true),
      isActive: e.target.checked,
    };
    form.setFieldsValue(fieldsValue);
  };

  const handleFieldChange = (changedValues: any, _allValues: any) => {
    for (const key in changedValues) {
      dispatch(updateField({ field: key, value: changedValues[key] }));
    }
  };

  const onSaveSystemType = async () => {
    saveSystemType(systemType);
  };

  const { mutate: saveSystemType, isPending: _isSavingSystem } = useMutation({
    mutationFn: (formData: any) => SystemTypeService.upsert(systemType.id, formData),
    onSuccess: (data: any) => {
      if (data) {
        handleResponse(data, data?.response?.name);
        dispatch(updateProps({ field: 'isModalVisible', value: false }));
        dispatch(updateProps({ field: 'refresh', value: !systemType.props.refresh }));
      }
    },
    onError: (error: any) => {
      message.error(error.message);
    },
  });

  useEffect(() => {
    form.setFieldsValue(systemType);
  }, [systemType]);

  return (
    <Form
      form={form}
      name='systemTypeForm'
      onValuesChange={handleFieldChange}
      initialValues={initialValues}
      onFinish={onSaveSystemType}
      layout='vertical'
    >
      <Divider />

      <Row gutter={16} className='row'>
        <Col xs={24} sm={12} className={`col ${width > 700 ? 'col-wide' : 'col-narrow'}`}>
          <Form.Item label='Denumire' name='name' rules={[{ required: true, message: 'Introdu denumire!' }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} className={`col ${width > 700 ? 'col-wide' : 'col-narrow'}`}>
          <Form.Item label='Status' name='isActive' valuePropName='checked'>
            <Checkbox onChange={() => handleCheckboxChange} />
          </Form.Item>
        </Col>
        <Col xs={24}>
          <Form.Item label='Operatiuni' name='operations'>
            <TextArea style={{ height: '150px' }} />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item>
        <Button type='primary' htmlType='submit'>
          Finalizare
        </Button>
      </Form.Item>
    </Form>
  );
};

export default InfoDeviceForm;
